import { Box, Button, SxProps } from '@mui/material'

import { DefaultElementProps } from 'common/interfaces'
import { mainButtonStyle } from 'common/styles'
import SaveFlowSessionLinkModal from 'components/Modals/SaveFlowSessionLinkModal'
import { SizingContainer } from 'components/SizingContainer'
import { useUpdateFlowSession } from 'utils/flowSession'
import { useBoolean, useFlowSessionId, useFlowState } from 'utils/hook'

import { SaveFlowButton as SaveFlowButtonProps } from './interface'

const style: SxProps = {
  color: 'text.secondary',
}

export default function SaveFlowButton({
  text = 'Save for later',
  variant = 'text',
  textModal = 'You will need the following link to save your progress and continue the flow at a later time.',
  textCopyButtonModal = 'Copy link',
  textCancelButtonModal = 'Return to flow',
}: SaveFlowButtonProps & DefaultElementProps): JSX.Element {
  const [isModalOpen, openModal, closeModal] = useBoolean(false)

  const flowState = useFlowState()
  const flowSessionId = useFlowSessionId()
  const { mutate: updateFlowSession } = useUpdateFlowSession()

  const saveFlowSessionHandle = (): void => {
    updateFlowSession({
      id: flowSessionId,
      ...flowState,
    })
    openModal()
  }

  return (
    <SizingContainer className="save-flow-btn-wrap">
      <Box sx={mainButtonStyle.container}>
        <Button onClick={saveFlowSessionHandle} sx={style} variant={variant}>
          {text}
        </Button>
      </Box>
      {isModalOpen && (
        <SaveFlowSessionLinkModal
          onClose={closeModal}
          open={isModalOpen}
          title={text}
          textModal={textModal}
          textCopyButtonModal={textCopyButtonModal}
          textCancelButtonModal={textCancelButtonModal}
        />
      )}
    </SizingContainer>
  )
}
